import React, {Component} from "react"
import {Link} from "react-router"
import {translate} from "translate"
import {Glyph, Button} from "elemental"
import CartButton from "../Cart/CartButton"
import shop from "shop/shop"
import "./header.scss"

import app from "../../app.controller"
// import Navigation from "../Navigation/Navigation"

export default class HeaderMobile extends Component {
  openSidebar = () => {
    app.sidebarLeft.open.dispatch()
  }

  render() {
    return (
      <div className="bg-silver tc pb3 pt3 fixed top-0 left-0 right-0 fadeInDown animated"
           style={{zIndex: 9}}>
        <div className="fl pl2">
          <Button onClick={this.openSidebar}
                  className="mr2">{translate("nav.menu")}</Button>
          <Link to="/search"><Button>Suche</Button></Link>
          <Link to="/" className="ml3">
            <img
              width="67"
              height="37"
              src="/logo.png"
              alt="MAGS Vertrieb" />
          </Link>

        </div>
        <div className="menu ">

          <div className="fr pr2">
            {/*<Link to="/quickorder"><Button type="link">{translate("nav.quickorder")}</Button></Link>*/}
            {/*<Link to="/orderlist"><Button type="link">{translate( "nav.orderlist" )}</Button></Link>*/}

            {/*<Link to="/search"><Button type="link"><i className="icon icon-fw icon-search"/></Button></Link>*/}
            {/*<Link to="/account" type="link"><Button type="link"><i className="icon icon-fw icon-user"/></Button></Link>*/}

            {shop.session && <CartButton />}
            {!shop.session && <Link className=""
                                    type="link"
                                    to="/login"><Button>Login</Button></Link>}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/HeaderMobile.js